import api from "./axios";

export const NotificationListing = (params) =>
  api
    .get("/common/notification-history/", { params })
    .then(({ data }) => data.data);

export const clearNotification = async (payload) => {
  const response = await api.post(
    "/common/notification-history/delete/",
    payload,
  );
  return response.data;
};

export const readNotification = async (payload) => {
  const response = await api.post("/common/notification/mark-read/", payload);
  return response.data;
};
